import { toast } from "vue-sonner";

// Thin adapter that exposes an Element-Plus-like API on top of vue-sonner,
// so existing `this.$message.*` / `ElMessage({...})` calls render as sonner
// toasts without rewriting every call site.
function show(arg) {
  // Element Plus style: ElMessage({ message, type }) or ElMessage("text")
  if (typeof arg === "string") return toast(arg);
  const msg = (arg && arg.message) || "";
  const type = (arg && arg.type) || "info";
  return notify[type] ? notify[type](msg) : toast(msg);
}

const notify = (arg) => show(arg);
notify.success = (m, o) =>
  toast.success(typeof m === "string" ? m : m?.message, o);
notify.error = (m, o) => toast.error(typeof m === "string" ? m : m?.message, o);
notify.warning = (m, o) =>
  toast.warning(typeof m === "string" ? m : m?.message, o);
notify.info = (m, o) => toast(typeof m === "string" ? m : m?.message, o);

export { notify, toast };
export default notify;
